import { ReactComponent as TopRight } from "@assets/images/top-right.svg";
import useProjectContext from "@utils/hooks/context/useProjectContext";
import useDynamicImage from "@utils/hooks/ui/useDynamicImage";
import ru from "../../../../../public/locales/ru/translation.json";
import classes from "./Project.module.scss";

type PropsType = {
  work: typeof ru["portfolio"][0]["projects"][0];
};

const Project = (props: PropsType) => {
  const { work } = props;

  const { project } = useProjectContext();

  const { src } = useDynamicImage(`projects/${project.id}/list/${work.id}.png`);

  return (
    <li className={classes.work__item}>
      <a href={work.link} className={classes.work__link} target="_blank" rel="noreferrer">
        <img className={classes.work__img} src={src} alt="" />
        <div className={classes["work__text-wrapper"]}>
          <span className={classes.work__text}>{work.text}</span>
          <TopRight className={classes.work__icon} />
        </div>
      </a>
    </li>
  );
};

export default Project;
